import Head from "next/head";
import { GA_ID, existsGaId } from "../utils/gtag";

const Meta = ({
  pageTitle,
  pageDescription,
  pagePath,
  pageImg,
  noIndex,
  ogTitle,
}) => {
  const defaultTitle = "株式会社トッカシステムズ";
  const defaultDescription = "あなたのビジネスにトッカするシステムを。";
  const defaultImgUrl = "https://tocca.systems/ogp-icon.png";
  const defaultTwAcount = "@toccasystems";
  const title = pageTitle ? `${pageTitle} | ${defaultTitle}` : defaultTitle;
  const ogTitleOutput = ogTitle
    ? ogTitle
    : pageTitle
    ? pageTitle
    : defaultTitle;
  const description = pageDescription ? pageDescription : defaultDescription;
  const url = pagePath;
  const imgUrl = pageImg ? pageImg : defaultImgUrl;
  const imgWidth = 1200;
  const imgHeight = 630;

  return (
    <Head>
      <title>{title}</title>
      <meta name="viewport" content="width=device-width,initial-scale=1.0" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={ogTitleOutput} />
      <meta property="og:site_name" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={imgUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={defaultTwAcount} />
      {noIndex && <meta name="robots" content="noindex" />}
      <link rel="canonical" href={url} />
      {/* Google Analytics */}
      {existsGaId && (
        <>
          <script
            async
            src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
          />
          <script
            dangerouslySetInnerHTML={{
              __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${GA_ID}', {
                page_path: window.location.pathname,
              });
              gtag('config', 'AW-18145522848');`,
            }}
          />
        </>
      )}
    </Head>
  );
};

export default Meta;
